import * as React from 'react';

export class BatchListEmpty extends React.Component<{}, {}> {
	render() {
		return <div>No batches</div>;
	}
}
